import { Component, OnInit } from '@angular/core';
import { AuthService } from '@lciapps/auth';

@Component({
  selector: 'app-protected',
  template: `
    <div class="container">
      <h1 style="margin-bottom: 50px;">
        Protected Area!
      </h1>
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <h3>Profile Data</h3>
            <table class="table table-bordered">
              <tbody>
              <tr *ngFor="let item of userInfoArr">
                <th scope="row">{{item[0]}}</th>
                <td>{{item[1]}}</td>
              </tr>
              </tbody>
            </table>
            <p style="overflow-wrap: break-word;"><strong>Raw user info:</strong><br/>
              {{rawUser | json}}
            </p>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./protected.component.scss']
})
export class ProtectedComponent implements OnInit {
  userInfo = {};
  userInfoArr = [];
  rawUser = {};

  constructor(private authService: AuthService) {
  }

  ngOnInit() {
    this.userInfo = this.authService.user.profile;
    this.rawUser = this.authService.user;
    for (const key in this.userInfo) {
      this.userInfoArr.push([key, this.userInfo[key]]);
    }
  }

}
